import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import { mainService } from 'src/store/server/main/_legacy/_legacy.main.service';
import type { APICommonResponse } from 'src/types/common.types';

import type {
  MainBannerListResponse,
  MainCollectionListResponse,
  MainNewsListResponse,
  MainNoticeList,
  MainNoticeListResponse,
  MainPartnerListResponse,
  MainPopupListResponse,
  MainPopupNoticeList,
  MainPopupNoticeListResponse,
  MainRankingList,
  MainRankingListResponse,
} from '@/service/main/_legacy/_legacy.main.dto';

export const USE_MAIN_QUERY_KEY = {
  mainPopupNoiceList: 'main-popup-notice-list',
  mainNoticeList: 'main-notice-list',
  mainBannerList: 'main-banner-list',
  mainRankingList: 'main-ranking-list',
  mainCollectionList: 'main-collection-list',
  mainPopupList: 'main-popup-list',
  mainNewsList: 'main-news-list',
  mainParterList: 'main-parter-list',
};

// getPopupNoticeList

export const usePopupNoticeListQuery = (
  select?: (response: APICommonResponse<MainPopupNoticeListResponse>) => MainPopupNoticeList,
) => {
  return useQuery([USE_MAIN_QUERY_KEY.mainPopupNoiceList], () => mainService.getPopupNoticeList(), {
    select,
    keepPreviousData: true,
  });
};

export const useMainNoticeListQuery = (
  select?: (response: APICommonResponse<MainNoticeListResponse>) => MainNoticeList,
) => {
  return useQuery([USE_MAIN_QUERY_KEY.mainNoticeList], () => mainService.getMainNoticeList(), {
    select,
    keepPreviousData: true,
  });
};

export const useMainBannerListQuery = (
  select?: (response: APICommonResponse<MainBannerListResponse>) => MainBannerListResponse,
) => {
  return useQuery([USE_MAIN_QUERY_KEY.mainBannerList], () => mainService.getMainBannerList(), {
    select,
    keepPreviousData: true,
  });
};

export const useMainRankingListQuery = (
  select?: (response: APICommonResponse<MainRankingListResponse>) => MainRankingList,
) => {
  return useQuery([USE_MAIN_QUERY_KEY.mainRankingList], () => mainService.getMainRankingList(), {
    select,
    keepPreviousData: true,
  });
};

export const useMainCollectionListQuery = (
  select?: (response: APICommonResponse<MainCollectionListResponse>) => MainCollectionListResponse,
) => {
  return useQuery([USE_MAIN_QUERY_KEY.mainCollectionList], () => mainService.getMainCollectionList(), {
    select,
    keepPreviousData: true,
  });
};

export const useMainPopupListQuery = (
  select?: (response: APICommonResponse<MainPopupListResponse>) => MainPopupListResponse,
) => {
  return useQuery([USE_MAIN_QUERY_KEY.mainPopupList], () => mainService.getMainPopupList(), {
    select,
    keepPreviousData: true,
  });
};

export const useMainNewsListQuery = (
  select?: (response: APICommonResponse<MainNewsListResponse>) => MainNewsListResponse,
) => {
  return useQuery([USE_MAIN_QUERY_KEY.mainNewsList], () => mainService.getMainNewsList(), {
    select,
    keepPreviousData: true,
  });
};

export const useMainPartnerListQuery = (
  select?: (response: AxiosResponse<MainPartnerListResponse>) => MainPartnerListResponse,
) => {
  return useQuery([USE_MAIN_QUERY_KEY.mainParterList], () => mainService.getMainPartnerList(), {
    select,
    keepPreviousData: true,
  });
};
